module.exports = __webpack_public_path__ + "img/bike.97ce26b4.png";